import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

//Components
import Alert from '../../Alert';
import TableComponent from '../../TableComponent';
import Paginator from '../../Paginator';
import OrderCard from '../../OrderCard';
import SectionTitle from '../../SectionTitle';
import Skeleton from '@mui/material/Skeleton';

//Dependencies
import getEstadoCuenta_Linaje from '../../Queries/getEstadoCuenta_Linaje';

// Styles
import styles from './index.module.sass';
import { useCallback } from 'react';
import getCookie from '../../Queries/getCookie';

const Lineage = (props) => {
  const { device, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('lineage');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [linage, setLinage] = useState([]);
  const [totPages, countPages] = useState(0);
  const [actualPage, movitPage] = useState(1);
  const linageItems = t('lineage', { returnObjects: true });

  function handlePage(e) {
    setLinage([]);
    const value = e.target.value;
    movitPage(parseInt(value));
  }

  const getEstadoCuenta_LinajeQuerie = useCallback(async () => {
    setLoading(true);
    const kit = getCookie('usuarioOk');
    const response = await getEstadoCuenta_Linaje(actualPage, kit);
    const { tipoMensaje = 'error', listaKits = [], mensaje = '', count = 0 } = response;
    setSessionMessage(mensaje);
    if (tipoMensaje === 'error') {
      setAlertText(mensaje);
      setOpen(true);
    } else {
      setLinage(listaKits);
      if (actualPage === 1) {
        countPages(Math.ceil(parseInt(count) / 30));
      }
    }
    setLoading(false);
  }, [actualPage, setSessionMessage]);

  useEffect(() => {
    getEstadoCuenta_LinajeQuerie();
  }, [getEstadoCuenta_LinajeQuerie]);

  return (
    <div id={styles.Lineage} className={`${styles[screenSize]} ${styles.lineaje}`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <SectionTitle title={t('title')} subtitle={t('subTitle')} />
      <OrderCard>
        <div className={styles.container}>
          {(loading && (
            <div>
              <div className={styles.tabletitle}>{t('linageTitle')}</div>
              <TableComponent screenSize={screenSize} tableData={linage} tableItems={linageItems} />
              <Skeleton variant='rectangular' className={styles.loadingText} />
              <Skeleton variant='rectangular' className={styles.loadingText} />
              <Skeleton variant='rectangular' className={styles.loadingText} />
            </div>
          )) || (
            <>
              <div className={styles.tabletitle}>{t('linageTitle')}</div>
              <TableComponent screenSize={screenSize} tableData={linage} tableItems={linageItems} />
            </>
          )}
          <div>&nbsp;</div>
          <div className={styles.paginator2}>&nbsp;de {totPages}</div>
          {totPages > 0 && (
            <Paginator callback={handlePage} actualPage={actualPage} totPages={totPages} />
          )}
          <label className={styles.paginator2}>
            <div>{t('page')}: &nbsp;</div>
          </label>
          <div>&nbsp;</div>
        </div>
      </OrderCard>
    </div>
  );
};

export default Lineage;
